export default "__VITE_ASSET__uwyOnmTC__"